import React from 'react';

import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import { StyledButton, StyledTypography } from 'styles/common';

const ConfirmationModal = ({
  title,
  description,
  onConfirm,
  onCancel,
  cancelText = 'Cancel',
  confirmText = 'Confirm',
  open,
}) => (
  <Dialog
    open={open}
    onClose={onCancel}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-description">{description}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <StyledButton variant="outlined" onClick={onCancel} color="primary" bottomGutter={1} rightGutter={1}>
        <StyledTypography variant="body1" clickable>
          {cancelText}
        </StyledTypography>
      </StyledButton>
      <StyledButton variant="contained" onClick={onConfirm} color="primary" rightGutter={2} bottomGutter={1} autoFocus>
        <StyledTypography variant="body1" clickable>
          {confirmText}
        </StyledTypography>
      </StyledButton>
    </DialogActions>
  </Dialog>
);

export default ConfirmationModal;
